// extracted by mini-css-extract-plugin
export var logo = "_iz-2";
export var logoWrapper = "_iz-1";
export var strip = "_iz-0";